import ProviderWrapper from './Wrapper';

class VideoVimeo extends ProviderWrapper {
  init() {
    const {
      id,
    } = this.dataParams;

    const isVideoExists = this.renderVideoOnPage();

    if (isVideoExists) return;

    this.player = this.connectVideoDefault();
    this.addPreviewImage(this.player);

    this.player.source = {
      type: 'video',
      sources: [
        {
          src: id,
          provider: 'vimeo',
        },
      ],
    };

    this.player.elements.poster.style.display = 'none';
  }
}

export default VideoVimeo;
